import { Pipe, PipeTransform } from '@angular/core';
import { TrackingData } from '../providers/tracking';
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: 'getCatalogMatch'
})

export class CatalogMatchPipe implements PipeTransform {

  constructor(
    private tracking: TrackingData
  ) { }

  transform(catalog: any, clientId: string, userId: string): any {
    if (catalog.ai) {
      return Observable.of(catalog);
    } else {
      return this.tracking.findEntityById(clientId, userId, catalog.id, 'catalog')
        .map(result => result.data);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/catalog-ai.pipe.ts